import { DotsThreeCircleIcon } from "@phosphor-icons/react";
import flagBadenWuerttemberg from "../../../assets/state-flags/baden-wuerttemberg.svg";
import flagBayern from "../../../assets/state-flags/bayern.svg";
import flagBerlin from "../../../assets/state-flags/berlin.svg";
import flagBrandenburg from "../../../assets/state-flags/brandenburg.svg";
import flagBremen from "../../../assets/state-flags/bremen.svg";
import flagHamburg from "../../../assets/state-flags/hamburg.svg";
import flagHessen from "../../../assets/state-flags/hessen.svg";
import flagMecklenburgVorpommern from "../../../assets/state-flags/mecklenburg-vorpommern.svg";
import flagNiedersachsen from "../../../assets/state-flags/niedersachsen.svg";
import flagNordrheinWestfalen from "../../../assets/state-flags/nordrhein-westfalen.svg";
import flagRheinlandPfalz from "../../../assets/state-flags/rheinland-pfalz.svg";
import flagSaarland from "../../../assets/state-flags/saarland.svg";
import flagSachsenAnhalt from "../../../assets/state-flags/sachsen-anhalt.svg";
import flagSachsen from "../../../assets/state-flags/sachsen.svg";
import flagSchleswigHolstein from "../../../assets/state-flags/schleswig-holstein.svg";
import flagThueringen from "../../../assets/state-flags/thueringen.svg";
import { NO_FEDERAL_STATE, type FederalStateChoice, type FederalStateCode } from "../../../constants/FederalStates";

const FLAG_BY_STATE: Record<FederalStateCode, string> = {
    BW: flagBadenWuerttemberg,
    BY: flagBayern,
    BE: flagBerlin,
    BB: flagBrandenburg,
    HB: flagBremen,
    HH: flagHamburg,
    HE: flagHessen,
    MV: flagMecklenburgVorpommern,
    NI: flagNiedersachsen,
    NW: flagNordrheinWestfalen,
    RP: flagRheinlandPfalz,
    SL: flagSaarland,
    SN: flagSachsen,
    ST: flagSachsenAnhalt,
    SH: flagSchleswigHolstein,
    TH: flagThueringen,
};

interface FederalStateFlagProps {
    choice: FederalStateChoice;
    /** Size and shape; the flag fills it. */
    className: string;
}

/** The state's flag; "no federal state" gets the "…" of the onboarding's "other" option instead. */
const FederalStateFlag = (props: FederalStateFlagProps) =>
    props.choice === NO_FEDERAL_STATE ? (
        <span
            aria-hidden="true"
            className={`${props.className} flex items-center justify-center bg-background-light`}
        >
            <DotsThreeCircleIcon
                weight="fill"
                className="text-xl text-p6-grey-mid"
            />
        </span>
    ) : (
        <img
            src={FLAG_BY_STATE[props.choice]}
            alt=""
            className={`${props.className} object-cover`}
        />
    );

export default FederalStateFlag;
